import Button from "devextreme-react/button";
import {useContext, useRef, useState} from "react";
import {EstimateContext} from "../context/EstimateContext";
import {Popup, ToolbarItem} from 'devextreme-react/popup';
import {TextBox} from "devextreme-react/text-box";
import {Validator, RequiredRule} from "devextreme-react/validator";
import {ValidationSummary} from "devextreme-react/validation-summary";
import {usePlaceOrder} from "../api/place-order";
import {showErrorMessage, showSuccessMessage} from "../../../../utils/messages";
import {queryClient} from "../../../../lib/react-query";

export default function PlaceOrderButton() {
    const {order} = useContext(EstimateContext);
    const [isPopupVisible, setIsPopupVisible] = useState<boolean>(false);
    const refProjectNumber = useRef<TextBox>(null);
    const placeOrder = usePlaceOrder(order.details.quoteID);

    const getCloseButtonOptions = {
        stylingMode: 'contained',
        text: 'Close',
        type: 'normal',
        onClick: () => setIsPopupVisible(false)
    };

    return (
        <>
            <Popup
                visible={isPopupVisible}
                showTitle={true}
                width={300}
                height={340}
                title={"Place Order"}
                shading={true}
                showCloseButton={true}
                onHidden={() => {
                    setIsPopupVisible(false);
                }}
                position={'center'}
            > <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                disabled={placeOrder.isLoading}
                options={{
                    stylingMode: 'contained',
                    text: 'OK',
                    validationGroup: 'placeOrder',
                    onClick: async (e: any) => {
                        if (order.details.placeOrderSettings.isProjectNumberRequired) {
                            if (!e.validationGroup.validate().isValid) {
                                return;
                            }
                        }
                        let result = await placeOrder.mutateAsync({projectNumber: refProjectNumber.current?.instance.option("value") ?? ''});
                        if (result.isSuccess) {
                            showSuccessMessage("Retail Order has been created successfully");
                            setIsPopupVisible(false);
                            await queryClient.invalidateQueries({queryKey: ['dealer-estimate', order.details.quoteID]});
                        } else
                            showErrorMessage(result.errorMessage!);
                    },
                }}
            />
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getCloseButtonOptions}
                />
                <div>
                    <p>
                        Are you sure you want to place this order?
                    </p>
                    <div className="dx-field">
                        <TextBox
                            mode={'text'}
                            ref={refProjectNumber}
                            width={'100%'}
                            label='Project Number'
                            labelMode={'outside'}
                            visible={order.details.placeOrderSettings.isProjectNumberRequired}
                        >
                            <Validator validationGroup="placeOrder">
                                <RequiredRule message={'Project Number is required'}/>
                            </Validator>
                        </TextBox>
                    </div>
                </div>
            </Popup>
            <Button
                text="Place Order"
                icon="Inscyth-Confirm"
                visible={order.details.placeOrderSettings.isVisible}
                disabled={!order.details.placeOrderSettings.isEnabled}
                onClick={() => {
                    refProjectNumber.current?.instance.clear();
                    setIsPopupVisible(true);
                }}>
            </Button>
        </>
    )
}
